/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import PageHeader from '../../components/ui/PageHeader';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { TabView, TabPanel } from 'primereact/tabview';
import { ClienteService } from '../../services/ClienteService';
import { useAuth } from '../../context/AuthContext';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import ActionToolbar from '../../components/ui/ActionToolbar';

const Clientes = () => {
    const { user, axiosInstance } = useAuth(); // Para llamadas directas a utilidades y extraccion de idEmpresa
    let emptyCliente = {
        id: null,
        tipoCliente: 'natural',
        tipoDocumento: 'DNI',
        numeroDocumento: '',
        nombres: '',
        apellidoPaterno: '',
        apellidoMaterno: '',
        razonSocial: '',
        representanteLegal: '',
        direccion: '',
        telefono: '',
        email: '',
        idEmpresa: user?.idEmpresa || 1
    };

    const [clientes, setClientes] = useState([]);
    const [clienteDialog, setClienteDialog] = useState(false);
    const [deleteClienteDialog, setDeleteClienteDialog] = useState(false);
    const [cliente, setCliente] = useState(emptyCliente);
    const [selectedClientes, setSelectedClientes] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const toast = useRef(null);
    const dt = useRef(null);

    // const { axiosInstance } = useAuth(); // Movido arriba

    // eslint-disable-next-line no-unused-vars
    const tipoClienteOptions = [
        { label: 'Persona Natural', value: 'natural' },
        { label: 'Persona Juridica', value: 'juridica' }
    ];

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            const data = await ClienteService.getAll();
            setClientes(data.data || []);
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudieron cargar los clientes', life: 3000 });
        }
    };

    const openNew = () => {
        let isJuridica = activeTabIndex === 1;
        setCliente({
            ...emptyCliente,
            tipoCliente: isJuridica ? 'juridica' : 'natural',
            tipoDocumento: isJuridica ? 'RUC' : 'DNI'
        });
        setSubmitted(false);
        setClienteDialog(true);
    };

    const hideDialog = () => {
        setSubmitted(false);
        setClienteDialog(false);
    };

    const hideDeleteClienteDialog = () => {
        setDeleteClienteDialog(false);
    };

    const saveCliente = async () => {
        setSubmitted(true);

        if (cliente.tipoCliente === 'natural' && cliente.tipoDocumento === 'DNI' && cliente.numeroDocumento.length !== 8) {
            toast.current.show({ severity: 'error', summary: 'DNI inválido', detail: 'El DNI debe tener 8 dígitos.', life: 3000 });
            return;
        }

        if (cliente.tipoCliente === 'juridica' && cliente.numeroDocumento.length !== 11) {
            toast.current.show({ severity: 'error', summary: 'RUC inválido', detail: 'El RUC debe tener 11 dígitos.', life: 3000 });
            return;
        }

        if (cliente.telefono && !/^\d{9}$/.test(cliente.telefono)) {
            toast.current.show({ severity: 'error', summary: 'Teléfono inválido', detail: 'El teléfono debe tener 9 dígitos.', life: 3000 });
            return;
        }

        if (cliente.numeroDocumento && ((cliente.tipoCliente === 'natural' && cliente.nombres) || (cliente.tipoCliente === 'juridica' && cliente.razonSocial))) {
            try {
                if (cliente.id) {
                    const response = await ClienteService.update(cliente.id, cliente);
                    if (!response?.success) {
                        throw new Error(response?.message || 'No se pudo actualizar el cliente');
                    }
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Cliente Actualizado', life: 3000 });
                } else {
                    const response = await ClienteService.create(cliente);
                    if (!response?.success) {
                        throw new Error(response?.message || 'No se pudo crear el cliente');
                    }
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Cliente Creado', life: 3000 });
                }
                setClienteDialog(false);
                setCliente(emptyCliente);
                loadData();
            } catch (error) {
                const message = error.response?.data?.message || error.message || 'No se pudo guardar el cliente';
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        }
    };

    const editCliente = (cliente) => {
        setCliente({ ...cliente });
        setClienteDialog(true);
    };

    const confirmDeleteCliente = (cliente) => {
        setCliente(cliente);
        setDeleteClienteDialog(true);
    };

    // eslint-disable-next-line no-unused-vars
    const deleteCliente = async () => {
        try {
            await ClienteService.delete(cliente.id);
            setDeleteClienteDialog(false);
            setCliente(emptyCliente);
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Cliente Eliminado', life: 3000 });
            loadData();
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo eliminar el cliente', life: 3000 });
        }
    };

    // eslint-disable-next-line no-unused-vars
    const onInputChange = (e, name) => {
        let val = (e.target && e.target.value) || '';
        if (name === 'numeroDocumento') {
            val = val.replace(/[^0-9]/g, '');
            if (cliente.tipoCliente === 'juridica') {
                val = val.slice(0, 11);
            } else if (cliente.tipoDocumento === 'DNI') {
                val = val.slice(0, 8);
            } else {
                val = val.slice(0, 12);
            }
        }
        if (name === 'telefono') {
            val = val.replace(/[^0-9]/g, '').slice(0, 9);
        }
        let _cliente = { ...cliente };
        _cliente[name] = val;

        if (name === 'tipoCliente') {
            _cliente.tipoDocumento = val === 'juridica' ? 'RUC' : 'DNI';
        }

        setCliente(_cliente);
    };

    const buscarDNI = async () => {
        if (!cliente.numeroDocumento) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Ingrese un número de DNI', life: 3000 });
            return;
        }
        setIsSearching(true);
        try {
            const response = await axiosInstance.get(`/api/reniec/consulta/${cliente.numeroDocumento}`);
            if (response.data) {
                setCliente(prev => ({
                    ...prev,
                    nombres: response.data.nombres || '',
                    apellidoPaterno: response.data.apellidoPaterno || '',
                    apellidoMaterno: response.data.apellidoMaterno || ''
                }));
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Datos obtenidos de RENIEC', life: 3000 });
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo consultar el DNI', life: 3000 });
        } finally {
            setIsSearching(false);
        }
    };

    const buscarRUC = async () => {
        if (!cliente.numeroDocumento || cliente.numeroDocumento.length !== 11) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Ingrese un RUC válido de 11 dígitos', life: 3000 });
            return;
        }
        setIsSearching(true);
        try {
            const response = await axiosInstance.get(`/api/empresas/search/ruc/${cliente.numeroDocumento}`);
            const rucData = response.data.data || response.data;
            if (rucData) {
                setCliente(prev => ({
                    ...prev,
                    razonSocial: rucData.razonSocial || rucData.nombre || '',
                    direccion: rucData.direccion || ''
                }));
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Datos obtenidos de SUNAT', life: 3000 });
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo consultar el RUC', life: 3000 });
        } finally {
            setIsSearching(false);
        }
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" rounded outlined className="mr-2" onClick={() => editCliente(rowData)} title="Editar" />
                <Button icon="pi pi-trash" rounded outlined onClick={() => confirmDeleteCliente(rowData)} title="Eliminar" />
            </React.Fragment>
        );
    };



    const clienteDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" outlined onClick={hideDialog} />
            <Button label="Guardar" icon="pi pi-check" onClick={saveCliente} />
        </React.Fragment>
    );

    const deleteClienteDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" outlined onClick={hideDeleteClienteDialog} />
            <Button label="Sí, Eliminar" icon="pi pi-check" onClick={deleteCliente} severity="danger" />
        </React.Fragment>
    );

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <PageHeader
                    title="Gestión de Clientes"
                    description="Administre el directorio de clientes de la empresa."
                    icon="pi pi-users"
                />
                <div className="card shadow-2 border-round-xl">
                    <Toast ref={toast} />
                    <TabView activeIndex={activeTabIndex} onTabChange={(e) => setActiveTabIndex(e.index)}>
                        <TabPanel header="Persona Natural" leftIcon="pi pi-user mr-2">
                            <ActionToolbar
                                onNew={openNew}
                                newLabel="Nuevo Cliente"
                                onSearch={(val) => setGlobalFilter(val)}
                                searchValue={globalFilter}
                                searchPlaceholder="Buscar cliente natural..."
                                extraActions={null}
                            />
                            <DataTable ref={dt} value={clientes.filter(c => c.tipoCliente === 'natural')} selection={selectedClientes} onSelectionChange={(e) => setSelectedClientes(e.value)}
                                dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive p-datatable-sm"
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} clientes"
                                globalFilter={globalFilter} emptyMessage="No se encontraron clientes naturales." responsiveLayout="scroll">
                                <Column selectionMode="multiple" headerStyle={{ width: '4rem' }}></Column>
                                <Column field="tipoDocumento" header="Doc." sortable></Column>
                                <Column field="numeroDocumento" header="N° Documento" sortable></Column>
                                <Column header="Nombres y Apellidos" body={(r) => r.nombres + ' ' + (r.apellidoPaterno || '') + ' ' + (r.apellidoMaterno || '')} sortable></Column>
                                <Column field="telefono" header="Teléfono"></Column>
                                <Column field="email" header="Email"></Column>
                                <Column body={actionBodyTemplate}></Column>
                            </DataTable>
                        </TabPanel>
                        <TabPanel header="Persona Juridica" leftIcon="pi pi-buiilding mr-2">
                            <ActionToolbar
                                onNew={openNew}
                                newLabel="Nueva Empresa"
                                onSearch={(val) => setGlobalFilter(val)}
                                searchValue={globalFilter}
                                searchPlaceholder="Buscar empresa..."
                                extraActions={null}
                            />
                            <DataTable value={clientes.filter(c => c.tipoCliente === 'juridica')} selection={selectedClientes} onSelectionChange={(e) => setSelectedClientes(e.value)}
                                dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive p-datatable-sm"
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} clientes"
                                globalFilter={globalFilter} emptyMessage="No se encontraron clientes jurídicos." responsiveLayout="scroll">
                                <Column selectionMode="multiple" headerStyle={{ width: '4rem' }}></Column>
                                <Column field="numeroDocumento" header="RUC" sortable></Column>
                                <Column field="razonSocial" header="Razón Social" sortable></Column>
                                <Column field="representanteLegal" header="Representante"></Column>
                                <Column field="telefono" header="Teléfono"></Column>
                                <Column field="email" header="Email"></Column>
                                <Column body={actionBodyTemplate}></Column>
                            </DataTable>
                        </TabPanel>
                    </TabView>
                </div>
            </div>

            <Dialog visible={clienteDialog} style={{ width: '600px', maxWidth: '95vw' }} header={cliente.id ? "Editar Cliente" : "Nuevo Cliente"} modal className="p-fluid" footer={clienteDialogFooter} onHide={hideDialog}>
                <div className="formgrid grid mt-3">
                    <div className="field col-12">
                        <label htmlFor="tipoCliente">Tipo de Cliente</label>
                        <div className="p-inputgroup">
                            <Button label="Natural" onClick={() => {
                                setCliente({ ...cliente, tipoCliente: 'natural', tipoDocumento: 'DNI', numeroDocumento: '', razonSocial: '', nombres: '', apellidoPaterno: '', apellidoMaterno: '', direccion: '' });
                            }} className={cliente.tipoCliente === 'natural' ? 'p-button-primary' : 'p-button-outlined'} />
                            <Button label="Jurídico" onClick={() => {
                                setCliente({ ...cliente, tipoCliente: 'juridica', tipoDocumento: 'RUC', numeroDocumento: '', razonSocial: '', nombres: '', apellidoPaterno: '', apellidoMaterno: '', direccion: '' });
                            }} className={cliente.tipoCliente === 'juridica' ? 'p-button-primary' : 'p-button-outlined'} />
                        </div>
                    </div>

                    <div className="field col-12 md:col-6">
                        <label htmlFor="tipoDocumento">Tipo Documento</label>
                        <InputText id="tipoDocumento" value={cliente.tipoDocumento} disabled />
                    </div>

                    <div className="field col-12 md:col-6">
                        <label htmlFor="numeroDocumento">Número Documento</label>
                        <div className="p-inputgroup">
                            <InputText id="numeroDocumento" value={cliente.numeroDocumento} onChange={(e) => onInputChange(e, 'numeroDocumento')} required autoFocus className={submitted && !cliente.numeroDocumento ? 'p-invalid' : ''} />
                            {cliente.tipoCliente === 'natural' && (
                                <Button icon={isSearching ? "pi pi-spin pi-spinner" : "pi pi-search"} onClick={buscarDNI} disabled={isSearching} tooltip="Consultar RENIEC" />
                            )}
                            {cliente.tipoCliente === 'juridica' && (
                                <Button icon={isSearching ? "pi pi-spin pi-spinner" : "pi pi-search"} onClick={buscarRUC} disabled={isSearching} tooltip="Consultar SUNAT" />
                            )}
                        </div>
                        {submitted && !cliente.numeroDocumento && <small className="p-error">Documento es requerido.</small>}
                    </div>

                    {cliente.tipoCliente === 'natural' && (
                        <>
                            <div className="field col-12">
                                <label htmlFor="nombres">Nombres</label>
                                <InputText id="nombres" value={cliente.nombres} onChange={(e) => onInputChange(e, 'nombres')} required className={submitted && !cliente.nombres ? 'p-invalid' : ''} />
                                {submitted && !cliente.nombres && <small className="p-error">Nombre es requerido.</small>}
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="apellidoPaterno">Apellido Paterno</label>
                                <InputText id="apellidoPaterno" value={cliente.apellidoPaterno} onChange={(e) => onInputChange(e, 'apellidoPaterno')} />
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="apellidoMaterno">Apellido Materno</label>
                                <InputText id="apellidoMaterno" value={cliente.apellidoMaterno} onChange={(e) => onInputChange(e, 'apellidoMaterno')} />
                            </div>
                        </>
                    )}

                    {cliente.tipoCliente === 'juridica' && (
                        <>
                            <div className="field col-12">
                                <label htmlFor="razonSocial">Razón Social</label>
                                <InputText id="razonSocial" value={cliente.razonSocial} onChange={(e) => onInputChange(e, 'razonSocial')} required className={submitted && !cliente.razonSocial ? 'p-invalid' : ''} />
                                {submitted && !cliente.razonSocial && <small className="p-error">Razón Social es requerida.</small>}
                            </div>
                            <div className="field col-12">
                                <label htmlFor="representanteLegal">Representante Legal (Opcional)</label>
                                <InputText id="representanteLegal" value={cliente.representanteLegal} onChange={(e) => onInputChange(e, 'representanteLegal')} />
                            </div>
                        </>
                    )}

                    <div className="field col-12 md:col-6">
                        <label htmlFor="telefono">Teléfono</label>
                        <InputText id="telefono" value={cliente.telefono} onChange={(e) => onInputChange(e, 'telefono')} />
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="email">Email</label>
                        <InputText id="email" value={cliente.email} onChange={(e) => onInputChange(e, 'email')} />
                    </div>
                    <div className="field col-12">
                        <label htmlFor="direccion">Dirección</label>
                        <InputText id="direccion" value={cliente.direccion} onChange={(e) => onInputChange(e, 'direccion')} />
                    </div>
                </div>
            </Dialog>

            <Dialog visible={deleteClienteDialog} style={{ width: '450px' }} header="Confirmar" modal footer={deleteClienteDialogFooter} onHide={hideDeleteClienteDialog}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {cliente && <span>¿Estás seguro de que deseas eliminar a <b>{cliente.nombres || cliente.razonSocial}</b>?</span>}
                </div>
            </Dialog>

        </div>
    );
};

export default Clientes;
